import React from 'react'

/* タブのインポート
*  新しいタブをインポートしたら必ず下のmapにも追加すること
*/

import NenkinSetting from './NenkinSetting'
import KenkouSetting from './KenkouSetting'
import KoyouSetting from './KoyouSetting'
import KaigoSetting from './KaigoSetting'
import KodomoSetting from './KodomoSetting'
import KodomoShienSetting from './KodomoShienSetting'
import TaikyoSetting from './TaikyoSetting'
import SekkeiUnitPriceSetting from './SekkeiUnitPriceSetting'
import GetsugakuSetting from './GetsugakuSetting'
import UchiwakeSetting from './UchiwakeSetting'

const TabController = {
  getTabClass (className) {
    const map = {
      NenkinSetting,
      KenkouSetting,
      KoyouSetting,
      KaigoSetting,
      KodomoSetting,
      KodomoShienSetting,
      TaikyoSetting,
      SekkeiUnitPriceSetting,
      GetsugakuSetting,
      UchiwakeSetting
    }
    return map[className]
  },
  getTab (tabId, props = {}) {
    return React.createElement(this.getTabClass(tabId), props)
  }
}
export default TabController



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/TabController.js